import UserRegister from "../../Components/client/Register"



function Register() {
  return (
    <div>
     <UserRegister/>
       
    </div>
  )
}

export default Register